export const TOGGLE_ROCKETS = 'TOGGLE_ROCKETS';
export const toggle_rockets = () => ({ type: TOGGLE_ROCKETS });
